import { render } from "./RequisitionManagementPage.vue?vue&type=template&id=18483ba4"
import script from "./RequisitionManagementPage.vue?vue&type=script&lang=js"
export * from "./RequisitionManagementPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__